<template>
	<div class="animated fadeIn">
		<!-- Component -->
		<div class="row">
			<div class="col-sm-12">
				<b-card>
					<div slot="header">{{ $t('Main Info') }}</div>
					<tooltip label="chatbot name" placement="right" disabled>
						<input
							name="chatbot_name"
							v-model="record.chatbot_name"
							v-validate="'required'"
							:class="{'form-control': true, 'is-invalid': errors.has('chatbot_name')}"
							type="text"
						/>
						<span
							v-if="errors.has('chatbot_name')"
							class="invalid-feedback"
						>{{ $t(errors.first('chatbot_name')) }}</span>
					</tooltip>
					<tooltip label="chatbot description" placement="right" disabled>
						<textarea
							name="chatbot_description"
							v-model="record.chatbot_description"
							class="form-control"
							:placeholder="$t('chatbot description')"
						></textarea>
					</tooltip>
					<!-- Strat Fallback -->
					<tooltip label="Fallback Type" placement="right">
						<select class="form-control" v-model="record.chatbot_fallback_type">
							<option value="text">{{ $t('Text') }}</option>
							<option value="options">{{ $t('Options') }}</option>
							<option value="cmd">{{ $t('Redirect to another command') }}</option>
						</select>
					</tooltip>
					<div v-show="!(record.chatbot_fallback_type == 'cmd')">
						<tooltip label="Fallback Message" placement="right">
							<input
								name="chatbot_fallback_msg"
								v-validate="'required'"
								v-autocomplete
								v-model="record.chatbot_fallback_msg"
								:class="{'form-control': true, 'is-invalid': errors.has('chatbot_fallback_msg')}"
								:placeholder="$t('chatbot fallback msg')"
								block-status="off"
							/>
							<span
								v-if="errors.has('chatbot_fallback_msg')"
								class="invalid-feedback"
							>{{ $t(errors.first('chatbot_fallback_msg')) }}</span>
						</tooltip>
					</div>
					<div v-if="record.chatbot_fallback_type == 'options'">
						<tooltip label="fallback options" placement="top">
							<table class="table table-bordered table-striped table-sm">
								<thead>
									<tr>
										<td>{{ $t('title') }}</td>
										<td>{{ $t('postback') }}</td>
										<td>{{ $t('action') }}</td>
									</tr>
								</thead>
								<tbody v-if="record.chatbot_fallback_options">
									<tr
										v-for="(opt, index) in record.chatbot_fallback_options"
										:key="'chatbot_fallback_options_' + index"
									>
										<td>{{ opt.label }}</td>
										<td>{{ opt.val }}</td>
										<td>
											<i @click="handleFallbackOption('edit', index)" class="fa fa-edit fa-lg text-primary"></i>
											&nbsp;
											<i
												@click="handleFallbackOption('remove', index)"
												class="fa fa-remove fa-lg text-primary"
											></i>
										</td>
									</tr>
									<tr v-if="!record.chatbot_fallback_options.length" v-cloak>
										<td colspan="3">
											<div class="text-center">{{ $t('no data') }}!</div>
										</td>
									</tr>
								</tbody>
							</table>
						</tooltip>

						<!-- <form @submit.prevent="opt_mode == 'add' ? add_opt() : edit_opt()" data-vv-scope="fallback-options-scope">
                            <tooltip label="option_title" placement="top">
                                <input
                                    type="text"
                                    :placeholder="$t('option_title')"
                                    v-model="opt.label"
                                    name="fallback_title"
                                    v-validate="{ required: true }"
                                    :class="{'form-control': true, 'is-invalid': errors.has('fallback_title')}"
                                />
                                <span
                                    v-if="errors.has('fallback_title')"
                                    class="invalid-feedback"
                                >{{ $t(errors.first('fallback_title')) }}</span>
                            </tooltip>
                            <tooltip label="option_postback" placement="top">
                                <input
                                    type="text"
                                    :placeholder="$t('option_postback')"
                                    v-model="opt.val"
                                    name="fallback_postback"
                                    v-validate="{ required: true }"
                                    :class="{'form-control': true, 'is-invalid': errors.has('fallback_postback')}"
                                />
                                <span
                                    v-if="errors.has('fallback_postback')"
                                    class="invalid-feedback"
                                >{{ $t(errors.first('fallback_postback')) }}</span>
                            </tooltip>
                            <button
                                type="submit"
                                class="btn btn-primary btn-sm"
                            >{{ $t(opt_mode == 'add' ? 'add option' : 'edit option') }}</button>
						</form>-->
						<b-button
							variant="primary"
							@click.prevent="() => handleFallbackOption('new')"
							class="my-0"
							size="sm"
						>
							<font-awesome-icon icon="plus" />
							{{ $t('new option') }}
						</b-button>
					</div>
					<div v-show="record.chatbot_fallback_type == 'cmd'">
						<tooltip label="Command" placement="right">
							<select
								class="form-control"
								name="chatbot_fallback_command_id"
								v-validate="'required'"
								:class="{
                                        'form-control': true,
                                        'is-invalid': errors.has('chatbot_fallback_command_id'),
                                    }"
								:disabled="!all_commands.length"
								v-model="record.chatbot_fallback_command_id"
							>
								<option v-if="!all_commands.length" value="0">{{ $t('No commands currently registered') }}</option>
								<option
									v-for="(c, index) in all_commands"
									:key="'all_commands' + index"
									:value="c.command_id"
								>{{ c.service_name }} - {{ c.command_name }}</option>
							</select>
							<span
								v-if="errors.has('chatbot_fallback_command_id')"
								class="invalid-feedback"
							>{{ $t(errors.first('chatbot_fallback_command_id')) }}</span>
						</tooltip>
					</div>
					<!-- End Fallback -->
				</b-card>
			</div>
			<div class="col-sm-12 col-md-4">
				<div>
					<b-card>
						<div slot="header">
							{{ $t('Start Button') }}
							<label
								class="switch switch-sm switch-text switch-info float-right mb-0"
							>
								<input type="checkbox" v-model="record.chatbot_start_button_status" class="switch-input" />
								<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
								<span class="switch-handle"></span>
							</label>
						</div>
						<div v-if="record.chatbot_start_button_status">
							<tooltip label="label" placement="right">
								<input
									name="chatbot_start_button_label"
									v-model="record.chatbot_start_button_label"
									v-validate="'required'"
									:class="{
											'form-control': true,
											'is-invalid': errors.has('chatbot_start_button_label'),
										}"
									type="text"
								/>
								<span
									v-if="errors.has('chatbot_start_button_label')"
									class="invalid-feedback"
								>{{ $t(errors.first('chatbot_start_button_label')) }}</span>
							</tooltip>
							<tooltip label="postback" placement="right">
								<input
									name="chatbot_start_button_postback"
									v-model="record.chatbot_start_button_postback"
									v-validate="'required'"
									:class="{
											'form-control': true,
											'is-invalid': errors.has('chatbot_start_button_postback'),
										}"
									type="text"
								/>
								<span
									v-if="errors.has('chatbot_start_button_postback')"
									class="invalid-feedback"
								>{{ $t(errors.first('chatbot_start_button_postback')) }}</span>
							</tooltip>
						</div>
					</b-card>
				</div>
				<b-card>
					<div slot="header">
						<span>{{ $t('Facebook') }}</span>
						<div class="card-actions">
							<button @click.prevent="updateFacebookPages" style="width: auto;padding: .75rem;">
								<small class="text-muted">{{ $t('subscribe pages') }}</small>
							</button>
						</div>
					</div>

					<div v-if="record.apps.facebook.length">
						<tooltip label="Set your pages status" placement="right">
							<b-list-group>
								<b-list-group-item
									class="d-flex justify-content-between align-items-center"
									v-for="(page, i) in record.apps.facebook"
									:key="i"
								>
									{{ page.chatbot_app_credentials.name }}
									<b-badge variant="default">
										<label class="switch switch-sm switch-text switch-info float-right mb-0">
											<input type="checkbox" v-model="page.chatbot_app_status" class="switch-input" />
											<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
											<span class="switch-handle"></span>
										</label>
									</b-badge>
								</b-list-group-item>
							</b-list-group>
						</tooltip>
						<supported-feature feature="facebook"></supported-feature>
					</div>
				</b-card>
				<b-card>
					<div slot="header">
						{{ $t('telegram') }}
						<label class="switch switch-sm switch-text switch-info float-right mb-0">
							<input
								type="checkbox"
								v-model="record.apps.telegram[0].chatbot_app_status"
								class="switch-input"
							/>
							<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
							<span class="switch-handle"></span>
						</label>
					</div>
					<div v-if="record.apps.telegram[0].chatbot_app_status">
						<tooltip label="verify token" placement="right">
							<input
								name="telegram_verify_token"
								v-model="record.apps.telegram[0].chatbot_app_credentials.verify_token"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('telegram_verify_token')}"
								type="text"
							/>
							<span
								v-if="errors.has('telegram_verify_token')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('telegram_verify_token')) }}</span>
						</tooltip>
						<supported-feature feature="telegram"></supported-feature>
					</div>
				</b-card>

				<b-card>
					<div slot="header">
						{{ $t('whatsapp') }}
						<label class="switch switch-sm switch-text switch-info float-right mb-0">
							<input
								type="checkbox"
								v-model="record.apps.whatsapp[0].chatbot_app_status"
								class="switch-input"
							/>
							<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
							<span class="switch-handle"></span>
						</label>
					</div>
					<div v-if="record.apps.whatsapp[0].chatbot_app_status">
						<tooltip label="chatapi url" placement="right">
							<input
								name="chatapi_url"
								v-model="record.apps.whatsapp[0].chatbot_app_credentials.chatapi_url"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('chatapi_url')}"
								type="text"
							/>
							<span
								v-if="errors.has('chatapi_url')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('chatapi_url')) }}</span>
						</tooltip>

						<tooltip label="chatapi key" placement="right">
							<input
								name="verify_token"
								v-model="record.apps.whatsapp[0].chatbot_app_credentials.verify_token"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('verify_token')}"
								type="text"
							/>
							<span
								v-if="errors.has('verify_token')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('verify_token')) }}</span>
						</tooltip>
					</div>
				</b-card>

				<b-card>
					<div slot="header">
						{{ $t('hangouts') }}
						<label class="switch switch-sm switch-text switch-info float-right mb-0">
							<input
								type="checkbox"
								v-model="record.apps.hangouts[0].chatbot_app_status"
								class="switch-input"
							/>
							<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
							<span class="switch-handle"></span>
						</label>
					</div>
					<div v-if="record.apps.hangouts[0].chatbot_app_status">
						<tooltip label="verify token" placement="right">
							<input
								name="hangouts_verify_token"
								v-model="record.apps.hangouts[0].chatbot_app_credentials.verify_token"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('hangouts_verify_token')}"
								type="text"
							/>
							<span
								v-if="errors.has('hangouts_verify_token')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('hangouts_verify_token')) }}</span>
						</tooltip>
						<supported-feature feature="hangouts"></supported-feature>
					</div>
				</b-card>

				<!-- Parser -->
				<b-card>
					<div slot="header">{{ $t('Parser') }}</div>
					<div>
						<tooltip
							v-for="(lang, lang_key) in parser_languages"
							:key="lang_key"
							:label="lang"
							placement="right"
							disabled
						>
							<select v-model="record.chatbot_parser[lang_key]" class="form-control">
								<option v-for="option in parser_options" :key="option" :value="option">{{ option }}</option>
							</select>
						</tooltip>
					</div>
				</b-card>
				<!-- End Bot Drivers configuration -->
			</div>
			<div class="col-sm-12 col-md-8">
				<div v-for="(menu, i) in chatbot_persistent_menus" :key="'persistent_menu_' + i">
					<PersistentMenuTree
						:parent="chatbot_persistent_menus[i]"
						:data="menu"
						:index="i"
						@onMenuTreeChanged="updatePersistentMenu"
					></PersistentMenuTree>
				</div>
			</div>
			<!-- MESSENGER SETTINGS START -->
			<div class="col-sm-12">
				<b-card class="mb-0">
					<div slot="header">{{ $t('Web Messenger Settings') }}</div>
					<div class="row">
						<div class="col-sm-12">
							<p class="h4 mb-3">{{ $t('main settings') }}</p>
							<tooltip label="default language" placement="right" disabled>
								<select
									name="default_lang"
									v-model="record.messenger_settings.default_lang"
									:class="{'form-control': true}"
								>
									<option value="undefined" disabled>{{ $t('Choose one') }}</option>
									<option value="ar">{{ $t('arabic') }}</option>
									<option value="en">{{ $t('english') }}</option>
								</select>
							</tooltip>

							<tooltip label="welcome msg" placement="right" disabled>
								<input class="form-control" type="text" v-model="record.messenger_settings.welcome_msg" />
							</tooltip>

							<tooltip label="Logo" placement="right" disabled>
								<image-uploader
									key="imageLogo"
									imageType="link"
									:linkInit="record.messenger_settings.logo"
									@imageSelected="(logo) => handleOnLogoImageSelected(logo.dataURI)"
									@linkChanged="handleOnLogoImageSelected"
									:imagePreview="false"
									:img="this.record.messenger_settings.logo"
								></image-uploader>
							</tooltip>

							<tooltip label="avatar" placement="right" disabled>
								<image-uploader
									key="imageAvatar"
									imageType="link"
									:linkInit="record.messenger_settings.avatar"
									@imageSelected="(avatar) => handleOnAvatarImageSelected(avatar.dataURI)"
									@linkChanged="handleOnAvatarImageSelected"
									:imagePreview="false"
									:img="this.record.messenger_settings.avatar"
								></image-uploader>
							</tooltip>

							<tooltip label="Main Color" placement="right" disabled>
								<color-chrome :value="record.messenger_settings.main_color" @input="setColor" />
							</tooltip>
							<tooltip label="size" placement="right" disabled noPlaceholder>
								<b-row class="form-group">
									<b-col md="6">
										<b-form-input
											@input="setSize('width')"
											type="number"
											min="330"
											placeholder="width"
											v-model="record.messenger_settings.width"
										></b-form-input>
									</b-col>
									<b-col md="6">
										<b-form-input
											type="number"
											@input="setSize('height')"
											placeholder="height"
											v-model="record.messenger_settings.height"
											max="700"
											min="400"
										></b-form-input>
									</b-col>
								</b-row>
							</tooltip>
							<tooltip
								label="Header Banner"
								placement="right"
								v-if="record.messenger_settings
                && typeof record.messenger_settings.header_injector !== 'object'"
							>
								<div class="codemirror-area">
									<codemirror
										v-model="record.messenger_settings.header_injector"
										:options="Object.assign({}, cmOptions, {readOnly: false})"
									/>
								</div>
							</tooltip>

							<tooltip label="Iframe Tag" placement="right" v-if="iframe_tag.length">
								<div class="codemirror-area">
									<button-copy :target="iframe_tag" />
									<codemirror :value="iframe_tag" :options="cmOptions" />
								</div>
							</tooltip>

							<tooltip label="Embed Code" placement="right" v-if="embed_code && embed_code.length">
								<div class="codemirror-area">
									<button-copy :target="embed_code" />
									<codemirror :value="embed_code" :options="cmOptions" />
								</div>
							</tooltip>

							<hr />

							<p class="h4 mb-3">{{ $t('speech settings') }}</p>
							<tooltip label="Speech type" placement="right">
								<select
									name="type"
									v-model="record.messenger_settings.voice.type"
									:class="{'form-control': true, 'is-invalid': errors.has('type')}"
								>
									<option value="UNKNOWN">{{ $t('detect browser') }}</option>
									<template v-for="(type, index) in $store.state.speech_cloud.types">
										<option :key="'types' + index" v-if="!type.disabled" :value="type.value">{{ type.label }}</option>
									</template>
								</select>
								<span v-if="errors.has('type')" class="help invalid-feedback">{{ $t(errors.first('type')) }}</span>
							</tooltip>
							<tooltip label="Default Language" placement="right">
								<select
									name="lang"
									v-model="record.messenger_settings.voice.lang"
									:class="{'form-control': true, 'is-invalid': errors.has('lang')}"
									v-validate="'required'"
								>
									<option value disabled>{{ $t('Choose one') }}</option>
									<template v-for="(lang, li) in $store.state.speech_cloud.langs">
										<option :key="li" v-if="!lang.disabled" :value="lang.value">{{ lang.label }}</option>
									</template>
								</select>
								<span v-if="errors.has('lang')" class="help invalid-feedback">{{ $t(errors.first('lang')) }}</span>
							</tooltip>
							<tooltip
								label="credentials"
								placement="right"
								v-if="record.messenger_settings
                    && record.messenger_settings.voice
                    && record.messenger_settings.voice.type != 'UNKNOWN'"
							>
								<div class="codemirror-area">
									<codemirror
										v-model="record.messenger_settings.voice.credentials"
										:options="Object.assign({}, cmOptions, {
                          readOnly: false,
                          mode: 'application/ld+json',
                        })"
									/>
								</div>
							</tooltip>
							<tooltip label="status" disabled placement="right">
								<div class="d-b">
									<c-switch
										class="m-0"
										type="icon"
										size="sm"
										variant="success"
										v-bind="{on: '\uf00c', off: '\uf00d'}"
										:pill="true"
										@change="
												record.messenger_settings.voice.status = !record.messenger_settings
													.voice.status
											"
										:checked="!!record.messenger_settings.voice.status"
									/>
								</div>
							</tooltip>
						</div>
					</div>
				</b-card>
			</div>
			<!-- MESSENGER SETTINGS END -->

			<div class="col-sm-12">
				<b-card v-if="record_id && chatbot_user_id">
					<div slot="header">
						<i class="mr-1 fa fa-align-justify"></i>
						{{ $t('bots instructions') }}
					</div>
					<table class="table table-bordered table-striped table-hover table-light table-sm mb-0">
						<thead>
							<tr>
								<th v-for="(field, i) in instructionFields" :key="i">{{ $t(field.key) }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, i) in instructionItems" :key="i">
								<td v-for="(field, i) in instructionFields" :key="i">
									<b-badge v-if="field.key === 'status'" :variant="getBadge(item.status)">{{ item.status }}</b-badge>
									<span v-else>{{ item[field.key] }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</b-card>
			</div>
			<div class="col-sm-12">
				<div class="form-actions">
					<b-button type="button" variant="primary" @click.prevent="save">
						<font-awesome-icon icon="save" />
						{{$t('save changes')}}
					</b-button>
					<b-button variant="dark" @click.prevent="previewChanges()">
						<font-awesome-icon icon="eye" />
						{{$t('preview changes')}}
					</b-button>
				</div>
			</div>
		</div>

		<b-modal
			size="lg"
			ref="fallbackOptionModal"
			:title="$t((fallbackOption.mode == 'new' ? 'New' : 'Edit') + ' fallback_option')"
			:no-close-on-backdrop="true"
			hide-footer
			@ok="handleFallbackOption('ok')"
			@cancel="handleFallbackOption('cancel')"
			@hide="handleFallbackOption('hide')"
		>
			<div class="row">
				<div class="col-sm-12" v-if="!(fallbackOption.mode == 'hide')">
					<tooltip label="option_title" placement="right">
						<input
							type="text"
							:placeholder="$t('option_title')"
							v-model="fallbackOption.label"
							name="fallback_title"
							v-validate="{ required: true }"
							:class="{'form-control': true, 'is-invalid': errors.has('fallback_title')}"
						/>
						<span
							v-if="errors.has('fallback_title')"
							class="invalid-feedback"
						>{{ $t(errors.first('fallback_title')) }}</span>
					</tooltip>
					<tooltip label="option_postback" placement="right">
						<input
							type="text"
							:placeholder="$t('option_postback')"
							v-model="fallbackOption.val"
							name="fallback_postback"
							v-validate="{ required: true }"
							:class="{'form-control': true, 'is-invalid': errors.has('fallback_postback')}"
						/>
						<span
							v-if="errors.has('fallback_postback')"
							class="invalid-feedback"
						>{{ $t(errors.first('fallback_postback')) }}</span>
					</tooltip>
					<div class="form-actions">
						<button type="button" @click="handleFallbackOption('save')" class="btn btn-primary btn-sm">
							<font-awesome-icon icon="save" />
							{{ $t(fallbackOption.mode =='new' ? 'save' : 'save change') }}
						</button>
						<button
							type="button"
							@click="handleFallbackOption('cancel')"
							class="btn btn-secondary btn-sm"
						>
							<font-awesome-icon icon="ban" />
							{{ $t('cancel') }}
						</button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import axios from 'axios'
import './form.scss'
import {cSwitch} from '../../components'
import PersistentMenuTree from '../../components/Tree/PersistentMenuTree'
import SupportedFeature from '../../components/SupportedFeature'
import {persistent_menus} from '../../components/Tree/shema'
import {filterMenus} from '../../components/Tree/helper'
import {Chrome as ColorChrome} from 'vue-color'
import {codemirror} from 'vue-codemirror'
import localStorage from '../../services/localStorage'
import loadMessenger from '../../mixins/loadMessenger'

/**
 * @vuese
 *
 * @group Chatbot Configuration
 *
 * Chatbot configuration Page
 */
export default {
	name: 'ChatbotForm',
	mixins: [loadMessenger],
	components: {
		cSwitch,
		PersistentMenuTree,
		'color-chrome': ColorChrome,
		codemirror,
		SupportedFeature,
	},
	computed: {
		/**
		 * @vuese
		 *
		 */
		instructionItems() {
			let items = [],
				drivers = ['facebook', 'telegram', 'hangouts', 'whatsapp'],
				loginLink = `${process.env.VUE_APP_SERVER_URL}/api/auth/${this.record_id}/${this.chatbot_user_id}/${this.user_token}`,
				broadcastLink = `${process.env.VUE_APP_SERVER_URL}/api/broadcast/${this.record_id}/${this.chatbot_user_id}/${this.user_token}`
			for (let i = 0; i < drivers.length; i++) {
				items.push({
					driver: drivers[i],
					login: `${loginLink}/${drivers[i]}`,
					subscribe_to: `${broadcastLink}/${drivers[i]}`,
					status: this.record.apps[drivers[i]].chatbot_app_status ? 'Active' : 'Inactive',
				})
			}
			return items
		},

		iframe_tag() {
			console.log(this.record.messenger_settings)
			let iframe_tag = this.record.messenger_settings.iframe_tag
			if (iframe_tag && this.sender_id) {
				return iframe_tag
					.replace(/SENDER_ID/g, this.sender_id)
					.replace(/LOCALE/g, this.record.messenger_settings.default_lang || 'en')
			}
			return ''
		},

		embed_code() {
			let embed_code = this.record.messenger_settings.embed_code
			if (embed_code && this.sender_id) {
				embed_code = embed_code
					.replace(/SENDER_ID/g, this.sender_id)
					.replace(/LOCALE/g, this.record.messenger_settings.default_lang || 'en')

				return embed_code
			}
			return ''
		},
	},

	data() {
		return {
			sender_id: null,
			instructionFields: [{key: 'driver'}, {key: 'login'}, {key: 'subscribe_to'}, {key: 'status'}],
			cmOptions: {
				mode: 'text/html',
				...this.$store.state.cm_base_options,
				readOnly: true,
			},
			record_id: 0,
			chatbot_user_id: 0,
			user_token: '0',
			all_commands: [],
			record: {
				messenger_settings: {
					width: '380',
					height: '600',
					logo: '',
					main_color: '#4066BF',
					embed_code: '',
					iframe_tag: '',
					welcome_msg: '',
					header_injector: '<!-- Type your code. -->\n',
					voice: {
						status: 1,
						type: 'UNKNOWN',
						lang: this.$store.state.speech_cloud.lang_default,
						credentials: '{\n\n}',
					},
					default_lang: 'en',
				},
				chatbot_name: '',
				chatbot_description: '',
				chatbot_fallback_type: 'text',
				chatbot_fallback_command_id: 0,
				chatbot_fallback_msg: '',
				chatbot_start_button_status: false,
				chatbot_start_button_label: 'ابدأ',
				chatbot_start_button_postback: 'مساعدة',
				chatbot_fallback_options: [],
				apps: {
					facebook: [],
					telegram: [
						{
							chatbot_app_status: false,
							chatbot_app_credentials: {
								verify_token: '',
							},
						},
					],
					whatsapp: [
						{
							chatbot_app_status: false,
							chatbot_app_credentials: {
								chatapi_url: '',
								verify_token: '',
							},
						},
					],
					hangouts: [
						{
							chatbot_app_status: false,
							chatbot_app_credentials: {
								verify_token: '',
							},
						},
					],
				},
				chatbot_parser: {
					ar: 'default',
					en: 'default',
					de: 'default',
				},
			},
			app_validate: true,
			chatbot_persistent_menus: [],
			persistent_menus: null,
			user: null,

			fallbackOption: {
				label: '',
				val: '',
				mode: 'hide',
			},
			whatsapp_code: '',

			// imagePreviewer: null,
			parser_languages: {
				ar: 'Arabic',
				en: 'English',
				de: 'German',
			},
			parser_options: ['default', 'embedding'],
		}
	},

	provide() {
		return {
			$validator: this.$validator,
		}
	},

	methods: {
		handleFallbackOption(mode, index = -1) {
			if (!this.$refs.fallbackOptionModal) {
				return false
			}
			switch (mode) {
				case 'save':
					const inputs = ['fallback_title', 'fallback_postback']

					this.$validator.validateAll(inputs).then((success) => {
						if (!success) {
							return
						}
						const option = {
							label: this.fallbackOption.label,
							val: this.fallbackOption.val,
						}
						if (
							'posation' in this.fallbackOption &&
							this.record.chatbot_fallback_options[this.fallbackOption.posation]
						) {
							this.record.chatbot_fallback_options[this.fallbackOption.posation] = option
						} else {
							this.record.chatbot_fallback_options.push(option)
						}
						this.handleFallbackOption('hide')
					})
					break
				case 'edit':
					let option = this.record.chatbot_fallback_options[index]
					if (option) {
						this.fallbackOption = {
							...option,
							mode: 'save',
							posation: index,
						}
						this.$refs.fallbackOptionModal.show()
						this.$nextTick(() => {
							this.$validator.reset()
						})
					}
					break
				case 'new':
				case 'hide':
					this.fallbackOption = {
						label: '',
						val: '',
						mode: mode,
					}
					this.$refs.fallbackOptionModal[mode == 'new' ? 'show' : 'hide']()
					this.$nextTick(() => {
						this.$validator.reset()
					})
					break
				case 'cancel':
					this.$refs.fallbackOptionModal.hide()
					break
				case 'remove':
					this.record.chatbot_fallback_options.splice(index, 1)
			}
		},

		getBadge(status) {
			return status === 'Active'
				? 'success'
				: status === 'Inactive'
				? 'secondary'
				: status === 'Pending'
				? 'warning'
				: status === 'Banned'
				? 'danger'
				: 'primary'
		},

		exist_option(label) {
			for (var i = 0; i < this.record.chatbot_fallback_options.length; i++) {
				if (this.record.chatbot_fallback_options[i].label === label) {
					return true
				}
			}
			return false
		},
		copy_to_clipboard(text) {
			window.copyToClipboard(text)

			this.$root.notify({
				message: this.$t('copied_successfully'),
				status: 'success',
				area: 'topRight',
			})
		},
		setColor(e) {
			this.record.messenger_settings.main_color = e.hex8
		},
		setLogo(e) {},
		setSize(c) {},
		postMessage(conf) {
			if ('postMessage' in window) {
				postMessage(window.hj.json.stringify(conf), '*')
			}
		},

		getValidationArray(parent) {
			return [parent.$validator.validateAll()].concat(
				[...parent.$children].reduce((prev, current) => {
					return prev.concat(this.getValidationArray(current))
				}, [])
			)
		},
		get_whatsapp_sample_code() {
			return (
				`<?php

					$curl = curl_init();

					curl_setopt_array($curl, array(
					CURLOPT_URL => "` +
				this.fullUrl(this.record.messenger_settings.whatsapp_web_hook) +
				`",
					CURLOPT_RETURNTRANSFER => true,
					CURLOPT_ENCODING => "",
					CURLOPT_MAXREDIRS => 10,
					CURLOPT_TIMEOUT => 0,
					CURLOPT_FOLLOWLOCATION => true,
					CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
					CURLOPT_CUSTOMREQUEST => "POST",
					CURLOPT_POSTFIELDS => array(
						'driver' => 'whats',
						'senderId' => 'ANY SENDER ID (e.g. 505050)',
						'message' => 'ANY MESSAGE GOES HERE'),
					CURLOPT_HTTPHEADER => array(
						"Content-Type: multipart/form-data; boundary=--------------------------015161455968850031307446"
					),
					));

					$response = curl_exec($curl);

					curl_close($curl);
					echo $response;
				`
			)
		},

		/**
		 * @vuese
		 *
		 * Save chatbot configuration
		 *
		 * /api/chatbot/save
		 *
		 * @arg {int} test this is the test wih default 0
		 */
		async save() {
			const validation = await Promise.all(this.getValidationArray(this))

			validation.some((element) => {
				if (element == false) {
					throw 'error validation'
				}
			})

			this.$root.loader = true
			axios
				.post('/chatbot/save', this.record)
				.then((response) => {
					this.$root.loader = false
					if (response.data.status == 1) {
						this.$store.commit('update_breadcrumb_history', {
							mode: 'chatbot',
							change_to: this.record.chatbot_name,
						})
						this.$root.notify({
							message: this.$t('successfully updated'),
							status: 'success',
							area: 'topRight',
						})
						this.previewChanges()
					}
				})
				.catch((e) => {
					console.warn(e)
					this.$root.loader = false
					this.$root.notify({
						message: this.$t('something not right '),
						status: 'error',
						autoHide: false,
						area: 'topRight',
					})
				})
		},

		updatePersistentMenu() {
			this.record.chatbot_persistent_menus = filterMenus(this.chatbot_persistent_menus.slice(0))
		},

		handleOnLogoImageSelected(value) {
			this.record.messenger_settings.logo = value
		},

		handleOnAvatarImageSelected(value) {
			this.record.messenger_settings.avatar = value
		},

		updateFacebookPages() {
			this.openRequestedSinglePopup(
				this.fullUrl(`/authorize/fb/${this.$store.state.user.user_id}`),
				'Facebook subscribe pages popup',
				() => {
					this.chatbBotBrowse()
				}
			)
		},
		chatbBotBrowse() {
			axios.get('/chatbot/browse').then((response) => {
				this.$root.loader = false

				if (response.data.status == 1) {
					if (Array.isArray(response.data.data.apps)) {
						response.data.data.apps = this.record.apps
					} else {
						response.data.data.apps = Object.assign(this.record.apps, response.data.data.apps)
					}

					this.record = {
						...this.record,
						...response.data.data,
					}

					this.chatbot_user_id = response.data.data.chatbot_user_id
					this.user_token = response.data.data.user_token

					if (!this.record.chatbot_fallback_options) {
						this.record.chatbot_fallback_options = []
					}

					this.chatbot_persistent_menus = this.record.chatbot_persistent_menus
						? response.data.data.chatbot_persistent_menus
						: persistent_menus
					this.updatePersistentMenu()

					if (
						!this.record.messenger_settings.hasOwnProperty('header_injector') ||
						this.record.messenger_settings.header_injector == null
					) {
						this.record.messenger_settings.header_injector = '<!-- Type your code. -->\n'
					}

					if (!this.record.messenger_settings.hasOwnProperty('width')) {
						this.record.messenger_settings.width = '380'
					}

					if (!this.record.messenger_settings.hasOwnProperty('height')) {
						this.record.messenger_settings.height = '600'
					}

					if (!this.record.messenger_settings.hasOwnProperty('voice')) {
						this.record.messenger_settings.voice = {
							status: 1,
							type: 'UNKNOWN',
							lang: this.$store.state.speech_cloud.lang_default,
							credentials: '{\n\n}',
						}
					}

					if (!this.record.chatbot_parser) {
						this.record.chatbot_parser = {
							ar: 'default',
							en: 'default',
							de: 'default',
						}
					}

					// if (!this.record.chatbot_parser.hasOwnProperty('ar')
					// 	|| !this.record.chatbot_parser.hasOwnProperty('en')
					// 	|| !this.record.chatbot_parser.hasOwnProperty('de')) {
					// }

					this.whatsapp_code = this.get_whatsapp_sample_code()

					this.record.messenger_settings.logo = this.record.messenger_settings.logo || ''
					// if (this.record.messenger_settings.hasOwnProperty('logo')) {
					// 	this.this.record.messenger_settings.logo = this.record.messenger_settings.logo
					// }

					this.previewChanges()
				}
			})
		},

		setSenderId() {
			let sender_id = null
			if ((sender_id = localStorage.get('sender_id'))) {
				this.sender_id = sender_id
			} else {
				sender_id = window.randomInt()
				axios
					.post('/validate-sender', {
						id: sender_id,
					})
					.then(({data}) => {
						if (data.status) {
							localStorage.set('sender_id', sender_id.toString())
							this.sender_id = sender_id
						} else {
							this.setSenderId()
						}
					})
			}
		},
	},
	created() {
		this.$root.loader = true
		this.chatbBotBrowse()
		// get all commands
		axios.post('/command/get_all', {}).then((response) => {
			if (response.data.status == 1) {
				this.all_commands = response.data.data.filter((cmd) => cmd.user_id == this.$store.state.user.user_id)
			}
		})

		this.setSenderId()

		// this.setSenderId()

		// this.$store.commit('watchDeference', this.record)
	},
}
</script>
